const { DateTime } = require("luxon");

const DateTimeNow = () => DateTime.now();

export const getDateFromFutureDays = (futureDay) => {
  return DateTimeNow().plus({ days: futureDay }).startOf("day").toISODate();
};

export const getDateFromPastDays = (pastDay) => {
  return DateTimeNow().minus({ days: pastDay }).startOf("day").toISODate();
};

export const parseDateToUSFormat = (date, timezone) => {
  let parsedDate = DateTime.fromISO(date, {setZone: true});
  if(timezone) {
    parsedDate = parsedDate.setZone(timezone)
  }
  const formattedDate = parsedDate.toFormat('MM-dd-yyyy');
  return formattedDate;
};

export const getDateTimeNow = (opts) => {
  return DateTimeNow().toISO(opts);
}